<template>
  <v-popover
      placement="bottom"
      offset="11"
      open-group="transaction-remove-popover"
      popoverClass="transaction-remove-popover">
    <div class="flex items-center group text-text-ternary hover:text-red
    transition duration-200 cursor-pointer">
      <IconTrash class="mr-4"/>
      <div class="text-2sm border-b border-dashed border-opacity-50 border-text-ternary
                  group-hover:text-red group-hover:border-red">{{ $t('remove') }}
      </div>
    </div>
    <template slot="popover">
      <div class="col-span-2">
        <p class="text-text text-lg font-bold">{{ $t('areYouSure') }}</p>
        <p class="text-text-ternary text-2sm">{{ $t('revertIsImpossible') }}</p>
      </div>
      <BaseButton size="sm"
                  v-close-popover
                  :disabled="submitted"
                  @click="$emit('remove')"
                  theme="red">{{ $t('yes') }}
      </BaseButton>
      <BaseButton size="sm"
                  v-close-popover
                  :disabled="submitted"
                  theme="white">{{ $t('no') }}
      </BaseButton>
    </template>
  </v-popover>
</template>

<script>
import BaseButton from "@/components/UI/BaseButton";
import IconTrash from "@/components/icons/IconTrash";

export default {
  name: "TransactionEditModalFormRemove",
  props: {
    submitted: {
      type: Boolean
    }
  },
  components: {IconTrash, BaseButton},
  data() {
    return {
      removePopup: false
    }
  },
  i18n: {
    messages: {
      en: {
        areYouSure: 'Are you sure?',
        revertIsImpossible: 'Cancel this action is impossible',
        remove: 'Delete',
        yes: 'Yes',
        no: 'No'
      },
      ru: {
        areYouSure: 'Вы уверены?',
        revertIsImpossible: 'Отменить действие невозможно',
        remove: 'Удалить',
        yes: 'Да',
        no: 'Нет'
      }
    }
  }
}
</script>

<style lang="scss">
.tooltip.popover.transaction-remove-popover {
  &:before{
    position: fixed;
    content: '';
  }
  &:focus {
    @apply outline-none;
  }

  .popover-inner {
    @apply p-4 bg-block shadow-primaryBlock rounded;
    width: 250px;
    z-index: 2;

    > div {
      @apply grid grid-cols-2 col-gap-4 row-gap-4;
    }
  }

  &[x-placement^="top"] {
    .popover-arrow {
      border-width: .8rem .8rem 0 .8rem;
      bottom: -.8rem;
    }
  }

  &[x-placement^="bottom"] {
    .popover-arrow {
      top: -.8rem;
      border-width: 0 .8rem .8rem .8rem;
    }
  }

  .popover-arrow {
    @apply border-block;
    z-index: 1;
    filter: drop-shadow(0px 4px 8px rgba(86, 114, 155, 0.6));

  }
}
</style>